import css from './input.module.css'

interface IProps {
  value: string
  name: string
  onChange: (value: string, name: string) => void
  autoFocus?: boolean
  inscription?: string
  placeHolder?: string
  onBlur?: () => void
}

const TextInput = (props: IProps) => {
  const handleChange = (e) => {
    const value = e.target.value
    props.onChange(value, props.name)
  }

  return (
    <div className={css.wrapper}>
      {props.inscription && <span className={css.inscription}>{props.inscription}</span>}
      <input
        className={css.input}
        value={props.value}
        autoFocus={props.autoFocus}
        onBlur={props.onBlur}
        onChange={handleChange}
        placeholder={props.placeHolder}
      />
    </div>
  )
}

export default TextInput
